import { createClient } from '@supabase/supabase-js';
import { Database } from '@/types/database';

// Get environment variables
if (!import.meta.env.VITE_SUPABASE_URL) {
  throw new Error('Missing environment variable: VITE_SUPABASE_URL');
}

if (!import.meta.env.VITE_SUPABASE_ANON_KEY) {
  throw new Error('Missing environment variable: VITE_SUPABASE_ANON_KEY');
}

// Initialize Supabase client with types
export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
    },
  }
);

// Re-export types from our types file for convenience
export type { PricingItem, DataItem, DataFormData } from '@/types/database';

// Legacy Tour type (keeping for backward compatibility)
export type Tour = {
  id: string;
  name: string;
  description: string;
  price: number;
  duration: string;
  max_participants: number;
  created_at: string;
  updated_at: string;
};
